module.exports = __webpack_public_path__ + "img/thumb_21.7db3cd45.jpg";